// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  root: '/app',
   apiUrldepricated:  'https://api.coloredstrategies.com', //this has been depricated JW url was for VienAngular template
   
  apiUrl:  'https://etrappbackendapidev.azurewebsites.net/api/', //this moved here from 'settings.json' (so that i can use 'angular.json' "configurations" for selecting eTrappDEV or eTrappPROD environments at build time 
  //...HISTORICALLY I HAD TO *MANUALLY* EDIT THE SETTINGS.JSON FILE TO SWITCH BETWEEN THE TWO ETRAPP ENVIRONMENTS!!
  
  googleMapsApiKey: 'AIzaSyBpOmcxEs_qSiNoMmakwBmYrsZMt1siK7o', // JWedit: customer production Google Maps key
  defaultMenuType: 'menu-default',
  subHiddenBreakpoint: 1440,
  menuHiddenBreakpoint: 768,
  themeColorStorageKey: 'vien-themecolor',
  isMultiColorActive: true,
  /*
  Color Options:
  'light.blueyale', 'light.blueolympic', 'light.bluenavy', 'light.greenmoss', 'light.greenlime', 'light.yellowgranola', 'light.greysteel', 'light.orangecarrot', 'light.redruby', 'light.purplemonster'
  'dark.blueyale', 'dark.blueolympic', 'dark.bluenavy', 'dark.greenmoss', 'dark.greenlime', 'dark.yellowgranola', 'dark.greysteel', 'dark.orangecarrot', 'dark.redruby', 'dark.purplemonster'
  */
  defaultColor: 'light.blueyale',
  isDarkSwitchActive: true,
  defaultDirection: 'ltr',
  themeRadiusStorageKey: 'vien-themeradius',
  isAuthGuardActive: true,
  firebase: {
    apiKey: 'AIzaSyBpOmcxEs_qSiNoMmakwBmYrsZMt1siK7o',
    authDomain: 'vien-angular-login.firebaseapp.com',
    databaseURL: 'https://vien-angular-login.firebaseio.com',
    projectId: 'vien-angular-login',
    storageBucket: 'vien-angular-login.appspot.com',
    messagingSenderId: '16217062888',
    appId: '1:16217062888:web:6b08232ca0c9662fedb85d',
    measurementId: 'G-8ETT79WRRN'
  }
};

